/* eslint-disable */
import React, { useEffect, useState } from "react";
import Container from "./Container";
import { Modal, TextField, Grid, Stack, Typography, Button, Box } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import ClearIcon from "@mui/icons-material/Clear";
import SaveIcon from "@mui/icons-material/Save";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { useGlobalDataContext } from "../../Context/AppGlobalData";
import MendetoryIcon from "./mendetoryicon";
import { usePopUpContext } from "../../Context/PopupMessage";
const ReleaseForShipmentModal = (props) => {
  const { shipmentReleaseDate, setShipmentReleaseDate, shipmentReleaseWeighht, setShipmentReleaseWeighht } =
    useGlobalDataContext();
  const { setPopupMessage, setLoading } = usePopUpContext();
  useEffect(() => {
    serErr(false)
    setShipmentReleaseWeighht(props.shipweight ? props.shipweight : props.weight)

    setShipmentReleaseDate(props.date)
  }, [props.open]);
  const handleSave = () => {

    if (props.weight && Number(shipmentReleaseWeighht) > Number(props.weight)) {

      setPopupMessage({ state: true, type: "error", message: "Can not ship more than : " + props.shipweightstr +" "+ props.wgtUm })
    }
    else if (err && err === "invalidDate") {
      setPopupMessage({ state: true, type: "error", message: "Fill correct Date and Time." })
    }
    else if (err && err === "disablePast") {
      setPopupMessage({ state: true, type: "error", message: "Ship Date can not be in the past." })
    }
    else {
      props.onSave()
    }
  }
  const [err, serErr] = useState(false)
  return (
    <Modal open={props.open}
    //  onClose={props.onClose}
    >
      <Container
        className="ixPopupLayout"
        position="absolute"
        top="25%"
        left="25%"
        sx={{
          overFlow: "auto", display: "flex",
          flex: 1, flexDirection: "column",
          height: props.weight ? "180px" : "150px",
          width: "500px",
          borderRadius: "5px"
        }} >
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          spacing={2} className="ixPopupHeader"  >
          <Box className="ixPopupHeaderTitle"> Release For Shipment</Box>
          <Button onClick={props.onClose} styletype="icon" className="ixButtonPopupHeader" >
            <ClearIcon />
          </Button>
        </Stack>


        <Stack
          direction="row"
          justifyContent="center"
          alignItems="center"
          padding={1}
          spacing={1}>


          <LocalizationProvider dateAdapter={AdapterDateFns}>


            <Grid container direction="row"
              spacing={2} >
              {props.weight ? <> <Grid item xs={2} textAlign="right">Weight <MendetoryIcon /></Grid>
                <Grid item xs={9} textAlign="left">
                  <TextField
                    sx={{ width: "150px" }}
                    type="number"
                    inputProps={{ inputMode: 'numeric', pattern: '[0-9]*' }}
                    value={shipmentReleaseWeighht}
                    onChange={(e) => {

                      setShipmentReleaseWeighht(e.target.value)


                    }}
                  />
                  <b> ( Max :</b>{"  " + props.shipweightstr +" " + props.wgtUm } <b>)</b>

                </Grid></>
                : null}



              <Grid item xs={2} textAlign="right">Date <MendetoryIcon /></Grid>
              <Grid item xs={4} textAlign="left">
                <DatePicker
                  disablePast
                  value={shipmentReleaseDate}
                  onChange={(newValue) => {
                    setShipmentReleaseDate(newValue);

                  }}
                  onError={(res, val) => {

                    serErr(res)
                  }}
                  renderInput={(params) => (
                    <TextField {...params} sx={{ width: "150px" }} />
                  )}
                /></Grid>
              <Grid item xs={2} textAlign="right">Time <MendetoryIcon /></Grid>
              <Grid item xs={4} textAlign="left"> <TimePicker
                value={shipmentReleaseDate}
                ampm={false}
                onChange={(newValue) => {

                  setShipmentReleaseDate(newValue);

                }}
                renderInput={(params) => (
                  <TextField {...params} sx={{ width: "150px" }} />
                )}
              /></Grid>



            </Grid>
          </LocalizationProvider>

        </Stack>

        <Stack sx={{ width: "100%", padding: "10px" }}
          direction="row"
          justifyContent="end"
          spacing={2}
          className="ixPopupFooter">
          <Button styletype="icon"
            onClick={handleSave}
            className="ixButtonPopup" >
            <SaveIcon />
          </Button>
        </Stack>
      </Container>
    </Modal>
  );
};

export default ReleaseForShipmentModal;
